export type IocType = 'ip' | 'domain' | 'url' | 'hash' | 'unknown';

const IPV4_RE = /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/;
const IPV6_RE = /^[0-9a-fA-F:]+$/;
const DOMAIN_RE = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
const HASH_RE = /^[a-fA-F0-9]+$/;

/**
 * Detect IOC type from a raw string. Mirrors the backend `detectIocType` in
 * `iocReputation.ts` so the client can pre-filter entities before calling the
 * batch endpoint (which caps at 25 IOCs per request).
 */
export function detectIocType(raw: string): IocType {
  const s = (raw ?? '').trim();
  if (!s) return 'unknown';
  if (/^https?:\/\//i.test(s)) return 'url';
  if (IPV4_RE.test(s)) return 'ip';
  if (IPV6_RE.test(s) && s.includes(':')) return 'ip';
  if (HASH_RE.test(s) && (s.length === 32 || s.length === 40 || s.length === 64)) return 'hash';
  if (DOMAIN_RE.test(s)) return 'domain';
  return 'unknown';
}
